<script lang="ts">
	import type { Image$data } from '$houdini';
	import CourseContentHighlights from '$lib/components/Course/CourseContentHighlights.svelte';
	import Image from '$lib/components/Image.svelte';

	export let title: string | undefined;
	export let thumbnail: Image$data | undefined | null;
	export let highlights: Array<string> | undefined;
</script>

<div class="w-1/2 hidden md:block">
	<div class="relative w-full h-full bg-lemon bg-svg bg-gradient-signup">
		<div class="flex flex-row justify-center items-center absolute w-full h-full">
			<div class="flex flex-col gap-4 max-w-[540px] px-2">
				{#if thumbnail}
					<Image
						loading="eager"
						fetchPriority="high"
						decoding="sync"
						class="object-cover mb-8"
						imageData={thumbnail}
					/>
				{/if}

				{#if highlights && title}
					<CourseContentHighlights
						additionalClass="px-5 min-w-full min-h-full"
						{title}
						titleClasses="font-bold text-2xl uppercase"
						icon="CheckMarkCircleIcon"
						iconClasses="w-5 h-5 min-h-fit mt-1"
						{highlights}
					/>
				{/if}
			</div>
		</div>
	</div>
</div>
